const css = `._jcdAq__label._jcdAq__label._jcdAq__label{color:var(--base-text-default);border-color:var(--base-surfaces-hover-secondary);background-color:var(--base-surfaces-hover-secondary);flex-shrink:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"label":"_jcdAq__label"};
